import { MapPin, ArrowUpRight } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { openWhatsApp } from "@/lib/whatsapp";

export const ProjectCard = ({ project, index, onOpen }) => {
  const enquire = (e) => {
    e.stopPropagation();
    openWhatsApp(
      `Hello, I'm interested in *${project.name}* (${project.type}) at ${project.location}. Please share more details.`
    );
  };

  return (
    <article data-testid={`property-card-${index + 1}`} className="group snap-start shrink-0 w-[82vw] sm:w-[360px] lg:w-[400px]">
      <div className="glass-card flex h-full flex-col overflow-hidden rounded-[24px]">
        {/* Clickable cinematic image */}
        <button
          type="button"
          onClick={() => onOpen(project)}
          aria-label={`View details for ${project.name}`}
          data-testid={`property-card-open-${index + 1}`}
          className="relative block aspect-[4/5] w-full overflow-hidden text-left focus-ring"
        >
          <img
            src={project.image}
            alt={`${project.name} \u2014 ${project.type} in ${project.location}`}
            loading="lazy"
            className="h-full w-full object-cover transition-[transform,filter] duration-700 ease-out group-hover:scale-[1.08] group-hover:brightness-[0.7]"
          />
          {/* Static bottom gradient for badge readability */}
          <div className="absolute inset-0 bg-gradient-to-t from-[rgba(12,12,12,0.6)] via-transparent to-transparent" />
          {/* Cinematic hover overlay (fades in) */}
          <div className="absolute inset-0 bg-gradient-to-t from-[rgba(12,12,12,0.92)] via-[rgba(12,12,12,0.35)] to-[rgba(12,12,12,0.15)] opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
          {/* Badge */}
          <span className="absolute top-4 left-4 rounded-full border border-[var(--border-hover)] bg-[rgba(12,12,12,0.6)] px-3 py-1.5 text-[11px] font-inter uppercase tracking-[0.14em] text-[var(--accent-cream)] backdrop-blur-md">
            {project.badge}
          </span>
          {/* More Info pill — reveals on hover */}
          <span className="pointer-events-none absolute inset-0 flex items-center justify-center">
            <span className="inline-flex translate-y-3 items-center gap-2 rounded-full border border-[var(--border-hover)] bg-[rgba(12,12,12,0.55)] px-5 py-2.5 text-sm font-semibold text-[var(--accent-cream)] opacity-0 backdrop-blur-md transition-[opacity,transform] duration-500 group-hover:translate-y-0 group-hover:opacity-100">
              More Info <ArrowUpRight size={16} />
            </span>
          </span>
        </button>

        <div className="flex flex-1 flex-col gap-3 p-5 md:p-6">
          <div className="font-inter text-[11px] uppercase tracking-[0.2em] text-[var(--text-accent)]">{project.type}</div>
          <h3 className="font-playfair text-2xl text-[var(--text-primary)]">{project.name}</h3>
          <div className="flex items-center gap-2 text-sm text-[var(--text-secondary)]">
            <MapPin size={15} className="text-[var(--accent-primary)]" /> {project.location}
          </div>
          <div className="mt-auto flex items-center gap-4 pt-2">
            <button
              data-testid={`property-card-info-${index + 1}`}
              onClick={() => onOpen(project)}
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-[var(--accent-secondary)] transition-colors hover:text-[var(--accent-cream)] focus-ring rounded-md"
            >
              More Info <ArrowUpRight size={15} />
            </button>
            <span className="h-4 w-px bg-[var(--border-subtle)]" aria-hidden="true" />
            <button
              data-testid={`property-card-cta-${index + 1}`}
              onClick={enquire}
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-[var(--accent-secondary)] transition-colors hover:text-[var(--accent-cream)] focus-ring rounded-md"
            >
              Enquire <FaWhatsapp size={14} />
            </button>
          </div>
        </div>
      </div>
    </article>
  );
};
